



























































import Vue from 'vue'
import API from '@/utils/api'
import Component from 'vue-class-component'
import { namespace } from 'vuex-class'
import { User } from '@/models/User'
import { Team } from '@/models/Team'
import { MainGame } from '@/models/MainGame'
import moment from '@/plugins/moment'
import { Roster as RosterModel } from '@/models/Roster'
import { Player } from '@/models/Player'
const AppStore = namespace('AppStore')
const SnackbarStore = namespace('SnackbarStore')

@Component({
  components: {},
})
export default class Roster extends Vue {
  moment = moment
  @SnackbarStore.Mutation setSnackbarError!: (error: string) => void
  loading: boolean = false
  choosenPlayerId: number = 0
  currentTeamId: number = 26
  currentGameId: number = 0
  games: MainGame[] = []
  players: Player[] = []
  teams: Team[] = []
  roster: RosterModel[] = []
  seasons: number[] = []
  currentSeason: number = 0
  headers: any[] = [
    { name: 'Name', value: (r: RosterModel) => r.player.name, type: 'text' },
    {
      name: 'Position',
      value: (r: RosterModel) => r.position.name,
      type: 'text',
    },
    {
      name: 'Is Active',
      value: 'is_active',
      type: 'checkbox-update',
    },
  ]
  markupData: any[] = []
  currentSeasonGames: MainGame[] = []
  positions: string[] = ['RB', 'QB', 'WR', 'TE']
  get currentGame() {
    return (
      this.games.find((g: MainGame) => g.id === this.currentGameId) || {
        id: -1,
      }
    )
  }
  get nextGame() {
    return this.games.find(
      (g: MainGame) =>
        g.week_id === ((this.currentGame as MainGame).week_id || 0) + 1
    )
  }
  get prevGame() {
    return this.games.find(
      (g: MainGame) =>
        g.week_id === ((this.currentGame as MainGame).week_id || 0) - 1
    )
  }
  get hasNextGame() {
    return !!this.nextGame
  }
  get hasPrevGame() {
    return !!this.prevGame
  }
  getHeaderValue(r: RosterModel, h: any) {
    //@ts-ignore
    return typeof h.value === 'function' ? h.value(r) : r[h.value]
  }
  setNextGame() {
    if (this.hasNextGame) {
      this.currentGameId = this.currentSeasonGames[this.currentGameIndex + 1].id
    }
  }
  get currentGameIndex() {
    let index = this.currentSeasonGames.indexOf(this.currentGame as MainGame)
    return index
  }
  addPlayerToCurrentTeam() {
    return API.newRoster({
      player_id: this.choosenPlayerId,
      team_id: this.currentTeamId,
      week_id: this.filteredRoster[0].week_id,
    }).then((r) => {
      this.loadRoster()
    })
  }
  setPrevGame() {
    if (this.hasPrevGame) {
      this.currentGameId = this.currentSeasonGames[this.currentGameIndex - 1].id
    }
  }
  get filteredRoster() {
    let currentWeek = (this.currentGame as MainGame).week_id || 0
    return this.roster.filter((r: RosterModel) => r.week_id === currentWeek)
  }
  isLastPos(m: RosterModel) {
    let filteredM = this.filteredRoster.filter(
      (o: RosterModel) => o.position.name == m.position.name
    )
    let lastM = filteredM[filteredM.length - 1]
    return (
      lastM.player.id === m.player.id &&
      this.roster[this.roster.length - 1].player.id !== m.player.id
    )
  }
  setCurrentSeasonGames() {
    let weekIds: number[] = []
    this.roster.forEach((e: RosterModel) => {
      weekIds.push(e.week_id)
    })
    this.currentSeasonGames = this.games.filter((g: MainGame) => {
      return (
        weekIds.includes(g.week_id) &&
        (g.home_team.id == this.currentTeamId ||
          g.away_team.id == this.currentTeamId)
      )
    })
  }
  loadSeasons() {
    return API.loadSeasons().then((r) => {
      this.seasons = r.data
      this.currentSeason = Math.max(...this.seasons)
    })
  }
  loadTeams() {
    return API.loadTeams().then((r) => {
      this.teams = r.data
    })
  }
  loadGames() {
    this.loading = true
    return API.loadGames().then((r) => {
      this.games = r.data
      this.loading = false
    })
  }
  updateIsActive() {
    this.loading = true
    return API.updateRoster(
      this.filteredRoster.map((r: RosterModel) => {
        return { id: r.id, is_active: r.is_active }
      })
    )
      .then((r: any) => {})
      .catch((err: any) => {})
      .finally(() => {
        this.loading = false
      })
  }
  loadRoster() {
    this.loading = true
    return API.loadSeasonRoster(this.currentTeamId, this.currentSeason)
      .then((r) => {
        this.roster = r.data
        this.setCurrentSeasonGames()
        let currentGameIds: number[] = []
        this.currentSeasonGames.forEach((g: MainGame) =>
          currentGameIds.push(g.id)
        )
        if (!currentGameIds.includes((this.currentGame as MainGame).id || -1)) {
          this.currentGameId = this.currentSeasonGames[0].id
        }
      })
      .catch((e) => {})
      .finally(() => {
        this.loading = false
      })
  }
  loadPlayers() {
    return API.loadPlayers().then((r) => {
      this.players = r.data
    })
  }
  mounted() {
    this.loadSeasons()
    this.loadTeams()
    this.loadGames()
    this.loadPlayers()
  }
}
